import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomTextField from "../../../Components/CustomTextField/CustomTextField";
import CustomSubmitButton from "../../../Components/CustomSubmitButton/CustomSubmitButton";
import Constant from "../../../Utils/Constant";
import LOGIN_BG from '../../../Assets/Images/login_bg.webp';
import { LOGIN_USER } from "../../../Redux/Slices/AuthSlices/Auth.action";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const userCheck = JSON.parse(localStorage.getItem("Interpreto"));
    if (userCheck) {
      if (userCheck?.role === 2) {
        navigate("/admin/dashboard")
      }
    }
  }, [location]);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required("Email address is required!").matches(Constant.REGEX.EMAIL, "Please Provide Valid Email Address!"),
      password: Yup.string()
        .required("Password is required!")
        .min(6, "Password must be at least 6 characters long!")
        .max(30, "Password must be at most 30 characters long!")
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true)
      await dispatch(
        LOGIN_USER({ email: values.email, password: values.password })
      )
        .unwrap()
        .then((res) => {
          if (res?.s === 1) {
            if (res?.r?.role === 2) {
              toast.success(res?.m);
              localStorage.setItem('Interpreto', JSON.stringify(res?.r))
              navigate("/admin/dashboard", { replace: true });
              resetForm();
              setIsLoading(false);
              const deviceId = moment();
              const currentTime = new Date();
              const hours = currentTime.getHours();
              const minutes = currentTime.getMinutes();
              const seconds = currentTime.getSeconds();
              const milliseconds = currentTime.getMilliseconds();
              const formattedTime = `${hours}:${minutes}:${seconds}.${milliseconds}`;
              const deviceIdWithTime = deviceId + formattedTime;
              localStorage.setItem("deviceId", deviceIdWithTime)
            } else {
              toast.error("You are not authorized to access");
              setIsLoading(false)
              resetForm();
            }
          } else {
            toast.error(res?.m);
            setIsLoading(false)
          }
        })
        .catch((error) => {
          toast.error("Registration failed. Please try again.");
          setIsLoading(false)
        });
    },
  });
  return (
    <>
      <Box
        sx={{
          backgroundImage: `url(${LOGIN_BG})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        }}
      >
        <Box
          sx={{
            width: "100%",
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
          }}
        >
          <Box
            sx={{
              width: { xs: "95%", sm: "60%", md: "50%", lg: "40%", xl: "30%" },

            }}
          >
            <Box
              sx={{
                width: "100%",
                backgroundColor: '#fff',
                borderRadius: "30px",
                py: 1,
                position: "relative",
                zIndex: "3",
                boxShadow: '0px 4px 20.8px 0px #00000040',
                opacity: 1
              }}
            >
              <Box sx={{ height: "100%", width: "100%", p: 3 }}>
                <Typography sx={{ fontSize: "36px", fontWeight: "600", color: 'rgba(0, 0, 0, 1)', fontFamily: "Outfit" }}>
                  Welcome Back!
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: "400", color: 'rgba(0, 0, 0, 0.8)', fontFamily: "Outfit" }}>
                  Please log in to access your dashboard and continue managing your account.
                </Typography>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                    return false;
                  }}
                  style={{
                    width: "100%",

                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "4px",
                    paddingTop: "20px",
                  }}
                >
                  <Box sx={{ width: "100%" }}>
                    <CustomTextField
                      label="Email"
                      type="text"
                      placeholder="Enter your email address"
                      name="email"
                      value={formik.values.email}
                      onBlur={formik.handleBlur}
                      onKeyUp={formik.handleBlur}
                      errors={formik.touched.email && formik.errors.email}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value.trimStart() !== value) {
                          e.target.value = value.trimStart();
                        }
                        formik.handleChange(e);
                      }}
                    />
                    
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <CustomTextField
                      label="Password"
                      type="password"
                      placeholder="Enter your password"
                      name="password"
                      value={formik.values.password}
                      onBlur={formik.handleBlur}
                      onKeyUp={formik.handleBlur}
                      errors={
                        formik.touched.password && formik.errors.password
                      }
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value.trimStart() !== value) {
                          e.target.value = value.trimStart();
                        }
                        formik.handleChange(e);
                      }}
                    />
                  </Box>
                  <Typography
                    style={{
                      width: "100%",
                      textAlign: "right",
                      fontSize: "16px",
                      color: 'rgba(0, 0, 0, 0.8)',
                      textDecoration: "none",
                      cursor: 'pointer',
                      fontWeight: "500",
                      fontFamily: "Outfit",
                      "&:hover": {
                        textDecoration: "underline",
                      }
                    }}
                    onClick={() => navigate('/forgot-password')}
                  >
                    Forgot Password?
                  </Typography>
                  <Box
                    sx={{
                      width: "55%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop:'5px'
                    }}
                  >
                    <CustomSubmitButton
                      btnTitle="Submit"
                      loading={isLoading}
                      type="submit"
                    />
                  </Box>
                </form>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Login;
